import { Room, TwilioError } from 'twilio-video';
import { useEffect } from 'react';
import queryString from 'query-string';

import { Callback } from '../../../types';

export default function useHandleRoomDisconnection(
  room: Room | null,
  onError: Callback,
  removeLocalAudioTrack: () => void,
  removeLocalVideoTrack: () => void,
  isSharingScreen: boolean,
  toggleScreenShare: () => void,
  logoutUrl?: string
) {
  useEffect(() => {
    if (room) {
      const onDisconnected = (_: Room, error: TwilioError) => {
        if (error) {
          onError(error);
        }

        removeLocalAudioTrack();
        removeLocalVideoTrack();
        if (isSharingScreen) {
          toggleScreenShare();
        }

        // 切断後にlogoutUrlに遷移
        if (logoutUrl) {
          const query = queryString.parse(window.location.search);
          const userType = query.type as string;

          // guestの場合のみ遷移（providerやviewerは遷移しない）
          if (userType === 'guest') {
            const withParamLogoutUrl = logoutUrl + '?logout=manual';
            window.location.href = withParamLogoutUrl;
          }
        }
      };

      room.on('disconnected', onDisconnected);
      return () => {
        room.off('disconnected', onDisconnected);
      };
    }
  }, [room, onError, removeLocalAudioTrack, removeLocalVideoTrack, isSharingScreen, toggleScreenShare, logoutUrl]);
}
